import React from 'react';
import { useNavigate } from '@tanstack/react-router';
import { withInject } from '@piwikpro/platform';
import { RouterService } from '@piwikpro/router-crate';
import CreateUserGroup from './CreateUserGroup';

interface CreateUserGroupRouteProps {
  routerService: RouterService
}

const CreateUserGroupRoute: React.FC<CreateUserGroupRouteProps> = ({ routerService }) => {
  const navigate = useNavigate();

  return (
    <CreateUserGroup
      finish={id => navigate({ to: '/administration/user-groups/$groupId', params: { groupId: id } })}
      abort={() => routerService.dismissAdministrationOverlay()}
    />
  );
};

export default withInject({
  routerService: 'RouterCrate.router',
})(CreateUserGroupRoute);
